import { Stack, styled, Typography } from '@mui/material';

export const InstantKnowledgeWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
  border: `1px solid ${theme.palette.greyBorder?.LIGHT + '35'}`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(4),
  height: '100%',
  flex: 1,
}));

export const InstantKnowledgeTitle = styled(Typography)(({ theme }) => ({
  letterSpacing: '-0.02em',
  marginBottom: '10px',
  background:
    'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0.8) 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 500,
}));
